/* @flow */
// typecheck: ignore file
import React from 'react';
import Group from 'entities/Group';
import PeopleTableRow from 'components/PeopleTableRow.jsx';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import GroupMembership from 'entities/GroupMembership';
import ScrollWatch from 'components/ScrollWatch.jsx';
import { connect } from 'react-redux';

import './styles/PeopleTableBody.scss';

type Props = {
  group: Group,
  allLoaded: boolean,
  loadNextPage: () => void,
  memberships: GroupMembership[],
  disabled?: boolean,
}

class PeopleTableBody extends React.Component {
  props: Props;

  onBottomReached = () => this.props.loadNextPage();

  render() {
    const { allLoaded, memberships, disabled } = this.props;

    const rows = memberships.map(m =>
      <PeopleTableRow key={m.id} membership={m} disabled={disabled} group={this.props.group} />
    );

    return (
      <tbody>
        {rows}
        {!allLoaded &&
          <tr>
            <td colSpan={99} className="PeopleTableBody-loading">
              <ScrollWatch onEnter={this.onBottomReached} threshold={0.2}>
                <LoadingIndicator size="large" />
              </ScrollWatch>
            </td>
          </tr>
        }
      </tbody>
    );
  }
}

function mapStateToProps(state: any, props: Props) {
  return {
    hasSelection: state.peopleTables.get(props.group.id).selectedMemberships.size > 0,
  };
}

export default connect(mapStateToProps, undefined)(PeopleTableBody);



// WEBPACK FOOTER //
// ./src/components/PeopleTableBody.jsx